import { render, staticRenderFns } from "./RubricSubmissions.vue?vue&type=template&id=57ac3eb2"
import script from "./RubricSubmissions.vue?vue&type=script&lang=js"
export * from "./RubricSubmissions.vue?vue&type=script&lang=js"
import style0 from "./RubricSubmissions.vue?vue&type=style&index=0&id=57ac3eb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports